
import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import filterStore from '../../stores/filterStore';
import requestStore from '../../stores/requestStore';
import { Button, TextField, Chip } from '@mui/material';
import logger from '../../utils/logger';


const KeywordsFilterField = observer(({ field, currentJsonFile, source }) => {
  const fieldJson = field.fieldJson; // например "description_contains"
  
  // Выбираем нужный стор в зависимости от источника
  const workStore = source === 'request' ? requestStore : filterStore;
  
  const currentVal = workStore.extraFilter[fieldJson];
  const keywords = Array.isArray(currentVal) ? currentVal : [];

  const [inputValue, setInputValue] = useState('');

  const addKeyword = () => {
    const newKeyword = inputValue.trim();
    if (!newKeyword) return;
    if (!Array.isArray(workStore.extraFilter[fieldJson])) {
      workStore.extraFilter[fieldJson] = [];
    }
    workStore.extraFilter[fieldJson].push(newKeyword);
    setInputValue('');
  };

  const removeKeyword = (word) => {
    const arr = workStore.extraFilter[fieldJson];
    if (Array.isArray(arr)) {
      const newArr = arr.filter((k) => k !== word);
      if (newArr.length === 0) {
        delete workStore.extraFilter[fieldJson];
      } else {
        workStore.extraFilter[fieldJson] = newArr;
      }
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
    
    {import.meta.env.VITE_SHOW_COMPONENT_NAME === 'true' && <div onClick={() => logger.log('KeywordsFilterField Render')}>% KeywordsFilterField %</div>}   

      <div className="flex flex-row">
        <TextField
          type="text"
          placeholder={field.placeholder || 'Например: срочно'}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              addKeyword();
            }
          }}
          size="small"
        />
        {/* <button onClick={addKeyword}>Добавить</button> */}
        <Button
          variant="outlined"
          color="primary"
          size="small"
          onClick={addKeyword}
          sx={{ textTransform: 'none', ml: 1 }}>
          Добавить
        </Button>
      </div>

      {/* "Чипы" */}
      <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
        {keywords.map((word) => (
          <Chip
            key={word}
            label={word}
            onDelete={() => removeKeyword(word)}
            size="small"
            sx={{ margin: '2px' }}
          />
        ))}
      </div>
    </div>
  );
});

export default KeywordsFilterField;
